import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const audiences = [
  {
    icon: 'ri-megaphone-line',
    title: 'Маркетинговые агентства',
    desc: 'Контекстная реклама, таргетинг, SMM, SEO.',
  },
  {
    icon: 'ri-code-s-slash-line',
    title: 'Разработка',
    desc: 'Создание сайтов, веб-сервисы, мобильные приложения.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Интеграторы CRM',
    desc: 'Bitrix24, AmoCRM, автоматизация бизнеса.',
  },
  {
    icon: 'ri-briefcase-4-line',
    title: 'B2B-услуги',
    desc: 'Консалтинг, аутсорсинг, внедрение решений.',
  },
  {
    icon: 'ri-team-line',
    title: 'Рекрутинг',
    desc: 'Подбор сотрудников и закрытие вакансий.',
  },
  {
    icon: 'ri-cloud-line',
    title: 'SaaS-компании',
    desc: 'Поиск клиентов на программные продукты.',
  },
];

export default function TLAudience() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { ref: descRef, revealed: descRevealed } = useScrollReveal({ delay: 200 });
  const { containerRef: cardsRef, revealedCount: cardsRevealed } = useScrollRevealGroup<HTMLDivElement>(6);

  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <span
              ref={labelRef}
              className={`inline-block text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}
            >
              Для кого
            </span>
            <h2
              ref={titleRef}
              className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}
            >
              Для кого создан AIGAM
            </h2>
          </div>
          <p
            ref={descRef}
            className={`text-[15px] text-foreground-500 max-w-md reveal-fade-up ${descRevealed ? 'revealed' : ''}`}
          >
            Если ваш продукт продаётся через переговоры — мы найдём тех, кто уже его ищет.
          </p>
        </div>

        <div ref={cardsRef} className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {audiences.map((item, idx) => (
            <div
              key={item.title}
              className={`group flex items-start gap-4 rounded-xl border border-background-200 bg-background-50 p-6 hover:border-primary-500 transition-colors cursor-default reveal-fade-up ${idx < cardsRevealed ? 'revealed' : ''}`}
              style={idx < cardsRevealed ? { transitionDelay: `${idx * 100}ms` } : undefined}
            >
              <span className="w-12 h-12 rounded-lg bg-background-950 text-background-50 flex items-center justify-center group-hover:bg-primary-500 transition-colors shrink-0">
                <i className={`${item.icon} text-[22px]`}></i>
              </span>
              <div>
                <h3 className="font-display font-bold text-[17px] text-foreground-950">{item.title}</h3>
                <p className="mt-1.5 text-[14px] text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}